import {
  CdkDrag,
  CdkDragHandle,
  CdkDropList,
  CdkDropListGroup
} from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';
import {
  CdkFixedSizeVirtualScroll,
  CdkVirtualForOf,
  CdkVirtualScrollViewport,
  ScrollingModule
} from '@angular/cdk/scrolling';
import { NgOptimizedImage } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { ResizableModule } from 'angular-resizable-element';
import { KeycloakAngularModule } from 'keycloak-angular';
import { NgApexchartsModule } from 'ng-apexcharts';
import { OrderModule } from 'ngx-order-pipe';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { AuthInterceptorService } from './app/services/interceptors/auth-interceptor.service';
import { SAVER, getSaver } from './app/services/providers/saver.provider';

function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}
const CORE_IMPORTS = [
  PortalModule,
  BrowserModule,
  AppRoutingModule,
  NgOptimizedImage,
  FormsModule,
  ReactiveFormsModule,
  ResizableModule,
  OrderModule
];

const MATERIAL_IMPORTS = [
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatTooltipModule,
  MatTreeModule
];

const CDK_DRAG_DROP_IMPORTS = [
  CdkDropListGroup,
  CdkDropList,
  CdkDrag,
  CdkDragHandle
];

const CDK_SCROLLING_IMPORTS = [
  ScrollingModule,
  CdkVirtualScrollViewport,
  CdkVirtualForOf,
  CdkFixedSizeVirtualScroll
];

const NGXS_IMPORTS = [NgxsReduxDevtoolsPluginModule.forRoot()];

const TRANSLATE_IMPORT = TranslateModule.forRoot({
  defaultLanguage: 'en',
  loader: {
    provide: TranslateLoader,
    useFactory: createTranslateLoader,
    deps: [HttpClient]
  }
});

const AUTH_INTERCEPTOR_PROVIDER = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptorService,
  multi: true
};

const KEYCLOAK_IMPORT = KeycloakAngularModule;

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      ...CORE_IMPORTS,
      ...MATERIAL_IMPORTS,
      ...CDK_DRAG_DROP_IMPORTS,
      ...CDK_SCROLLING_IMPORTS,
      ...NGXS_IMPORTS,
      TRANSLATE_IMPORT,
      NgApexchartsModule,
      KEYCLOAK_IMPORT
    ),
    AUTH_INTERCEPTOR_PROVIDER,
    { provide: SAVER, useFactory: getSaver },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations()
  ]
})
  .then((ref) => {
    // @ts-ignore
    window['ngRef']?.destroy();
    // @ts-ignore
    window['ngRef'] = ref;
  })
  .catch((err) => console.error(err));
